var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _ellipse1, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawEnvironmentIaus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 886,
    height: 654.3011,
    viewBox: "0 0 886 654.3011",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "environment1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M534.69721,566.28435s117.66268-14.11952,158.84462-36.47543,347.10492-32.94555,347.10492,36.47543S688.83533,666.29763,688.83533,666.29763L504.10491,655.708Z",
    transform: "translate(-157 -122.59945)",
    fill: "#fbbebe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M534.69721,566.28435s117.66268-14.11952,158.84462-36.47543,347.10492-32.94555,347.10492,36.47543S688.83533,666.29763,688.83533,666.29763L504.10491,655.708Z",
    transform: "translate(-157 -122.59945)",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M568.81939,553.34145l-24.70916,71.77424L157,629.8222V523.92578s148.255-34.12218,265.91766,38.82869C422.91766,562.75447,561.75963,546.28169,568.81939,553.34145Z",
    transform: "translate(-157 -122.59945)",
    fill: "#4da347"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M568.81939,553.22576,544.11023,625,157,629.70651V523.81009s148.255-34.12217,265.91766,38.82869C422.91766,562.63878,561.75963,546.166,568.81939,553.22576Z",
    transform: "translate(-157 -122.59945)",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.40421,523.33747c0,4.01013-8.99291,6.98746-9.87713,10.85578-.877,3.837,4.466,9.67153,2.7754,13.33593a72.56315,72.56315,0,0,1-6.17161,10.73274c-2.21493,3.17137-9.05694,2.70824-11.86227,5.68227a94.31858,94.31858,0,0,1-8.71239,7.57632c-2.97685,2.47558-7.00983,2.995-10.3949,5.27405-3.21855,2.16694-2.82908,10.11566-6.38943,12.089-3.40209,1.88559-8.60988.3689-12.30036,2.0638-3.54222,1.6268-5.41036,7.51078-9.19734,8.94966-3.65224,1.38768-8.17251.79041-12.03369,1.99233-3.737,1.16328-7.91819.97444-11.834,1.95379-3.8025.951-6.70671,6.651-10.66232,7.41945-3.854.74876-8.3706-1.24829-12.35568-.68116-3.89167.55383-8.41763-4.37162-12.421-3.9988-3.91842.36491-7.61086,2.64509-11.62382,2.8293-3.93486.18062-7.825,1.91354-11.839,1.91354-4.01326,0-8.155,3.76516-12.0891,3.58461-4.01286-.18416-7.64576-5.89119-11.56409-6.25606-4.00373-.37281-8.7793,5.58855-12.67133,5.03469-3.98495-.56708-7.14123-6.40236-10.99514-7.15107-3.95666-.76866-9.06677,3.40179-12.87023,2.45052-3.9163-.97949-6.24086-7.76777-9.97832-8.93124-3.86105-1.20193-8.64707.42607-12.29918-.96161-3.78762-1.43918-8.40158-1.20794-11.94434-2.83511-3.69044-1.695-6.33948-5.70566-9.74152-7.59135-3.56035-1.97344-5.20212-6.86749-8.42064-9.03457-3.38534-2.2794-8.543-1.98843-11.52-4.46441-3.143-2.614-9.03152-2.75028-11.684-5.56266-2.80531-2.97446-3.94048-7.96872-6.15524-11.14054-2.3325-3.34045,2.24541-10.40268.61691-13.93333-1.68988-3.66373-8.75561-5.15233-9.63228-8.98856a56.43529,56.43529,0,0,1-1.38412-12.20727c0-4.01013,6.04275-7.07505,6.927-10.94337.87705-3.837-3.5706-9.34765-1.88-13.012,1.62909-3.53111,1.4209-8.95885,3.75419-12.29969,2.21492-3.17137,7.74247-4.41466,10.54781-7.38869,2.65244-2.81195,7.39972-3.59649,10.54257-6.21012,2.97685-2.47558,2.59756-9.94153,5.98263-12.22058,3.21855-2.16693,7.71233-3.15553,11.27269-5.12883,3.40209-1.88559,8.2166-1.568,11.90708-3.26286,3.54222-1.62681,9.09051,1.57878,12.87749.1399,3.65223-1.38768,6.61443-4.42066,10.47561-5.62258,3.737-1.16327,5.49295-10.03477,9.40878-11.01411,3.8025-.951,8.48123.62756,12.43684-.14094,3.854-.74875,9.03982,6.25065,13.0249,5.68353,3.89167-.55383,6.80233-9.89764,10.80568-10.27046,3.91843-.36492,8.33653,4.4746,12.34949,4.29039,3.93486-.18061,7.88586,2.65493,11.89989,2.65493,4.01325,0,8.012-3.89163,11.9461-3.71108,4.01286.18417,7.55113,5.3271,11.46946,5.692,4.00373.37281,8.91865-7.44985,12.81068-6.896,3.98495.56708,7.06419,6.61418,10.91811,7.36288,3.95665.76866,8.91232-2.98574,12.71579-2.03447,3.9163.97948,6.27257,7.40675,10.01,8.57021,3.861,1.20194,6.23986,5.73621,9.892,7.12389,3.78763,1.43917,10.82321-5.29424,14.366-3.66707,3.69044,1.695,6.878,4.62825,10.28005,6.51394,3.56035,1.97344,9.22033.981,12.43884,3.14809,3.38534,2.2794,4.21769,8.39757,7.1947,10.87355,3.143,2.614,8.32722,3.401,10.97967,6.21338,2.80531,2.97446,3.195,8.304,5.40974,11.47584,2.33251,3.34045,2.25969,7.96873,3.88819,11.49938,1.68988,3.66373,6.20167,6.43485,7.07833,10.27108C1008.78607,514.895,1011.40421,519.32831,1011.40421,523.33747Z",
    transform: "translate(-157 -122.59945)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M587.64542,596.87665S720.60425,528.63229,806.498,554.51808s205.90969-18.826,220.02921-3.52988,34.12218,180.0239-135.31208,189.43692-314.15936-28.23905-314.15936-28.23905Z",
    transform: "translate(-157 -122.59945)",
    fill: "#fbbebe"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M556.33394,589.60871S608.8247,586.287,606.47145,605.113s-4.70651,164.72776-18.826,168.25764-125.89907,3.52988-171.78752,3.52988H157V551.32636s183.55378-10.9278,275.33068,34.96064C432.33068,586.287,542.67187,584.694,556.33394,589.60871Z",
    transform: "translate(-157 -122.59945)",
    fill: "#4da347"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M802.23938,236.77869a27.04128,27.04128,0,0,0-23.30891,16.29741c-5.82841,14.08872,1.67611,30.638,12.94175,40.91165s25.737,16.146,38.88553,23.86474c17.6606,10.3676,33.5301,24.75954,42.36669,43.23381s9.77646,41.35854-.61056,59.00773c-9.64093,16.38147-27.17132,26.18572-43.89076,35.22786",
    transform: "translate(-157 -122.59945)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M849.30446,150.88493a27.0413,27.0413,0,0,0-23.30892,16.29742c-5.82841,14.08871,1.67611,30.638,12.94175,40.91164s25.73705,16.146,38.88553,23.86474c17.66061,10.3676,33.5301,24.75955,42.3667,43.23382s9.77645,41.35853-.61057,59.00772c-9.64092,16.38147-27.17132,26.18572-43.89076,35.22786",
    transform: "translate(-157 -122.59945)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1004.05062,170.64a27.04127,27.04127,0,0,0-28.40774-1.38242c-13.23342,7.57224-17.43052,25.25222-14.81179,40.27235s10.46668,28.52256,16.13823,42.67515c7.61783,19.00927,11.35579,40.10422,7.03358,60.12177s-17.58823,38.688-36.60588,46.28493c-17.65163,7.05125-37.51521,4.072-56.271.98658",
    transform: "translate(-157 -122.59945)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 710.6826,
    cy: 211.88941,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.15272,
    cy: 209.53616,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 771.8672,
    cy: 200.12315,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 768.33732,
    cy: 197.76989,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 781.28021,
    cy: 251.89473,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 777.75033,
    cy: 249.54147,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 775.39708,
    cy: 122.46577,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 771.8672,
    cy: 120.11252,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 704.79947,
    cy: 114.22939,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 701.26959,
    cy: 111.87613,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 736.56839,
    cy: 84.81372,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 733.03851,
    cy: 82.46046,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 805.98938,
    cy: 90.69685,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 802.4595,
    cy: 88.3436,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 857.76096,
    cy: 129.52554,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 854.23108,
    cy: 127.17228,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.3838,
    cy: 61.28118,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 671.85392,
    cy: 58.92793,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 693.0332,
    cy: 16.56936,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 689.50332,
    cy: 14.21611,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 856.58433,
    cy: 49.51491,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 853.05445,
    cy: 47.16166,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 596.5498,
    cy: 157.76458,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 593.01992,
    cy: 155.41133,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 694.20983,
    cy: 150.70482,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 690.67995,
    cy: 148.35157,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 822.46215,
    cy: 161.29446,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 818.93227,
    cy: 158.94121,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 754.2178,
    cy: 166.00097,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 750.68792,
    cy: 163.64771,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 758.9243,
    cy: 48.33828,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 755.39442,
    cy: 45.98503,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 637.73174,
    cy: 121.28915,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 634.20186,
    cy: 118.93589,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.20452,
    cy: 174.23736,
    rx: 28.23904,
    ry: 13.71611,
    fill: "#57b894"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 650.67463,
    cy: 171.8841,
    rx: 28.23904,
    ry: 13.71611,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 806.26874,
    cy: 387.36508,
    rx: 14.7942,
    ry: 6.40684,
    transform: "translate(-82.2221 779.58806) rotate(-60.79941)",
    fill: "#57b894"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 804.40702,
    cy: 388.44307,
    rx: 14.7942,
    ry: 6.40684,
    transform: "translate(-84.11655 778.515) rotate(-60.79941)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 948.03219,
    cy: 414.81604,
    rx: 6.40684,
    ry: 14.7942,
    transform: "translate(-150.30628 722.00638) rotate(-48.17218)",
    fill: "#57b894"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 947.38726,
    cy: 412.76369,
    rx: 6.40684,
    ry: 14.7942,
    transform: "translate(-148.99179 720.84216) rotate(-48.17218)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 816.24999,
    cy: 340.68855,
    rx: 6.40684,
    ry: 14.7942,
    transform: "translate(-138.9674 599.1163) rotate(-48.17218)",
    fill: "#57b894"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 815.60505,
    cy: 338.6362,
    rx: 6.40684,
    ry: 14.7942,
    transform: "translate(-137.65292 597.95208) rotate(-48.17218)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawEnvironmentIaus);
export default __webpack_public_path__ + "static/media/undraw_environment_iaus.089839f4a2f95c2b5ae50b1052201355.svg";
export { ForwardRef as ReactComponent };